import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var CommentForm = require("components/social/comments/CommentForm");
var CommentLine = require("components/social/comments/CommentLine");
var CurrentUser = require("lib/account/CurrentUser");
var Features = require("lib/account/Features");
var Spinner = require("components/utility/Spinner");

var WritingActions = require("lib/actions/WritingActions");
var WritingSelectors = require("lib/selectors/WritingSelectors");

require("social/comments/comment_box.scss");

function propsToFilters(props) {
	return {
		subject_type: props.subjectType,
		subject_id: props.subjectID + "",
		subject_user_id: props.userID
	};
}

@connect(
	(state, props) => {
		return {
			comments: WritingSelectors.comments({
				state, filters: _.omit(propsToFilters(props), "subject_user_id")
			}),
			loading: WritingSelectors.isLoadingComments({
				state, key: props.subjectType + "|" + props.subjectID
			})
		}
	},
	(dispatch, props) => ({
		populateData: () => {
			return dispatch(WritingActions.fetchComments({
				filters: propsToFilters(props),
				embeds: ["comment.user"],
				cache: true,
				loadingKey: props.subjectType + "|" + props.subjectID
			}));
		},

		createComment: (comment, userID) => {
			return dispatch(WritingActions.createComment({
				comment: comment, embeds: ["comment.user"],
				query: { subject_user_id: userID }
			}));
		},

		updateComment: (commentID, comment, userID) => {
			return dispatch(WritingActions.updateComment({
				id: commentID, update: comment,
				query: { subject_user_id: userID }
			}));
		},

		deleteComment: (commentID, userID) => {
			return dispatch(WritingActions.deleteComment({
				id: commentID,
				query: { subject_user_id: userID }
			}));
		}
	})
)
@providePopulateData()
class CommentBox extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			collapsed: !!props.initialCollapsed,
			awaitingResponse: false
		};
	}

	isOwnItem() {
		return CurrentUser.hasID(this.props.userID);
	}

	deleteComment(toDeleteComment) {
		Mycroft.newEvent({ category: "Comment", action: "remove" });
		this.props.deleteComment(toDeleteComment.id, this.props.userID);
	}

	updateComment(toUpdateComment) {
		Mycroft.newEvent({ category: "Comment", action: "update" });
		this.props.updateComment(toUpdateComment.id, toUpdateComment, this.props.userID);
	}

	createComment(commentData) {
		if (!this.state.awaitingResponse && Features.isEnabled(Features.TEACHER_COMMENTS)) {

			Mycroft.newEvent({ category: "Comment", action: "create" });

			commentData = _.extend({}, commentData, {
				subject_id: this.props.subjectID,
				subject_type: this.props.subjectType,
			});

			this.setState({ awaitingResponse: true });
			
			this.props.createComment(commentData, this.props.userID).then(() => {
				this.setState({ awaitingResponse: false })
				// this.scrollDownComments();
				this.refs.newCommentForm.reset();
			})
		}
	}

	closeEditComments() {
		for (var i = 0; i < this.props.comments.length; i+=1) {
			var ref = "comment" + i;
			if (this.refs[ref]) {
				this.refs[ref].closeEdit();
			}
		}
	}

	getOrderedComments() {
		var comments = _.sortBy(this.props.comments, function(comment) {
			return new Date(comment.created_at).getTime();
		}.bind(this));

		return _.select(comments, function(comment) {
			if (!comment.secretive) {
				return true;

			} else if (CurrentUser.isAdmin() || this.isOwnItem()) {
				return true;

			} else if (CurrentUser.isSponsor()) {
				return comment.user.is_sponsor;
			} else {
				return false;
			}
			return !comment.secretive || CurrentUser.isAdmin() || this.isOwnItem();
		}.bind(this));
	}

	toggleCollapsed(e) {
		$wr.nope(e)
		if (Features.isEnabled(Features.TEACHER_COMMENTS)) {
			this.setState({ collapsed: !this.state.collapsed });
		} else if (this.props.showPaywallModal) {
			this.props.showPaywallModal();
		}
	}

	checkCommentingAbility(e) {
		if (!Features.isEnabled(Features.TEACHER_COMMENTS)) {
			if (this.props.showPaywallModal) {
				this.props.showPaywallModal();
			}
			$wr.nope(e)
		}
	}

	render() {
		if (this.state.collapsed) {
			return (
				<div className="commentBox" ref="commentBox">
					<a href="#" onClick={ this.toggleCollapsed }>
						Comment
					</a>
				</div>
			);
		}

		if (this.props.loading) {
			var content = (
				<Spinner placeholder scale={ 0.8 } />
			);
		} else if (this.props.comments) {
			var content = this.getOrderedComments().map(function(comment, index) {
				return <CommentLine comment={ comment } key={ comment.id || comment.body }
					ref={ "comment" + index } closeEditComments={ this.closeEditComments }
					updateComment={ this.updateComment } deleteComment={ this.deleteComment } />
			}.bind(this));			
		}

		if ((!this.props.blockNewComments) && (!this.props.blockFirstComment || (this.props.comments && this.props.comments.length > 0))) {
			var commentForm = (
				<div onClick={ this.checkCommentingAbility }>
					<CommentForm ref="newCommentForm" onSubmit={ this.createComment }
						noSuggestedComments={ this.props.noSuggestedComments } />
				</div>
			);
		}

		return (
			<div className="commentBox expanded" ref="commentBox">
				{ content }
				{ commentForm }
			</div>
		);
	}

	fetchComments(callback) {

		// var params = {
		// 	embed: "comment.user",
		// 	subject_type: this.props.subjectType,
		// 	subject_id: this.props.subjectID,

		// 	// Only used if subject type has no clear user ID
		// 	subject_user_id: this.props.userID
		// };
		// CurrentUser.api().getComments(params, $wr.apiHandler(function(response) {
		// 	this.setState({ comments: response.comments }, this.closeEditComments);
		// 	if (callback) {
		// 		callback();
		// 	};

		// 	setTimeout(() => {
		// 		$(window).trigger("resize");
		// 	}, 20);
		// }.bind(this)))
	}

	scrollDownComments() {
		setTimeout(function(){
			$(this.refs.commentBox).trigger("scroll-to-bottom");
		}.bind(this), 1000)
	}

	componentDidMount() {
		if ((this.props.comments == null) && !this.state.collapsed) {
			this.fetchComments();
		}
	}
};

CommentBox.WrappedComponent.propTypes = StrictPropTypes({
	// ID and type of the subject of the comments
	subjectID: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]).isRequired,
	
	subjectType: PropTypes.string.isRequired,

	// ID of the owner of the subject of the comments (if any). NOT the commenter's user ID
	userID: PropTypes.number,

	// Whether or not to start the container collapsed
	initialCollapsed: PropTypes.bool,

	// If this is true, don't show the form unless there are already comments here
	blockFirstComment: PropTypes.bool,

	// If this is true, don't show the form 
	blockNewComments: PropTypes.bool,

	// Function to call to display paywall modal
	showPaywallModal: PropTypes.func,

	noSuggestedComments: PropTypes.bool,

	// Data from @connect
	comments: PropTypes.array,
	loading: PropTypes.bool,

	// Handlers from @connect
	populateData: PropTypes.func,
	createComment: PropTypes.func,
	updateComment: PropTypes.func,
	deleteComment: PropTypes.func
});

module.exports = CommentBox;



// WEBPACK FOOTER //
// ./modules/components/social/comments/CommentBox.js